import { getCachedStore } from '../router/auth';

export default ({ name, components, map }) => ({
  name,
  components,
  data() {
    return {
      store: {}
    };
  },
  async created() {
    this.store = await getCachedStore();
  },
  render(h) {
    return h(map[this.store.kind]);
  }
});
